import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#050505] border-t border-white/10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-10">
      <div className="grid md:grid-cols-2 gap-16">
        <div>
          <p className="font-mono-j text-xs tracking-[0.2em] uppercase text-cyan-400 mb-6">
            Let's build together
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="group inline-flex items-center gap-3 font-display text-4xl sm:text-5xl font-bold text-white hover:text-cyan-400 transition-colors"
          >
            Start a project
            <span className="grid place-items-center w-12 h-12 rounded-full border border-white/20 group-hover:border-cyan-400 group-hover:bg-cyan-400 group-hover:text-black transition-colors">
              <ArrowUpRight />
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-8">
          <div>
            <p className="font-mono-j text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">Navigate</p>
            <ul className="space-y-3 text-zinc-400">
              {["Home", "About", "Services", "Work", "Contact"].map((l) => (
                <li key={l}>
                  <Link to={l === "Home" ? "/" : `/${l.toLowerCase()}`} className="hover:text-white transition-colors">
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono-j text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">Reach us</p>
            <ul className="space-y-3 text-zinc-400 text-sm">
              <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-cyan-400" /> hello@blueverait.com</li>
              <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-cyan-400" /> +91 98765 43210</li>
              <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-cyan-400" /> Bengaluru, India</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <h2 className="font-display font-black text-[19vw] leading-none tracking-tighter text-white/5 select-none">
        BLUEVERA
      </h2>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-500 font-mono-j">
        <span>© {new Date().getFullYear()} Bluevera IT Solutions Pvt. Ltd.</span>
        <span>Engineering the future, one system at a time.</span>
      </div>
    </div>
  </footer>
);
